import { render, staticRenderFns } from "./upsell-list.vue?vue&type=template&id=9124c3d6"
import script from "./upsell-list.vue?vue&type=script&lang=js"
export * from "./upsell-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports